import React from 'react'

import NextLink from 'next/link'
import { twMerge } from 'tailwind-merge'

import {
  COMMERCIAL_FRONTEND_URL,
  IS_FEDRAMP_ENVIRONMENT,
} from '@/constants/env'

interface LinkProps extends React.ComponentProps<typeof NextLink> {
  className?: string
  openInNewTab?: boolean
}

const Link: React.FC<LinkProps> = ({ className, openInNewTab, ...props }) => {
  return (
    <NextLink
      className={twMerge(
        'break-all text-sm text-blue-600 dark:text-blue-400 transition-opacity duration-100 hover:opacity-70',
        className,
      )}
      target={openInNewTab ? '_blank' : undefined}
      rel={openInNewTab ? 'noopener noreferrer' : undefined}
      {...props}
    />
  )
}

interface SweetspotLinkProps extends Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  'href'
> {
  href: string
  prefetch?: React.ComponentProps<typeof NextLink>['prefetch']
}

export const SweetspotLink: React.FC<SweetspotLinkProps> = ({
  href,
  target,
  rel,
  referrerPolicy,
  prefetch,
  ...props
}) => {
  if (IS_FEDRAMP_ENVIRONMENT) {
    const commercialHref = href.startsWith('/')
      ? `${COMMERCIAL_FRONTEND_URL}${href}`
      : href

    return (
      <a
        {...props}
        href={commercialHref}
        target="_blank"
        rel="noopener noreferrer"
        referrerPolicy="no-referrer"
      />
    )
  }

  return (
    <NextLink
      {...props}
      href={href}
      target={target}
      rel={rel}
      referrerPolicy={referrerPolicy}
      prefetch={prefetch}
    />
  )
}

export default Link
